/**
 * Configuration of available query params for SL broadcaster.
 */
export const liveQueryConfig = {
  /**
   * Param with event title.
   */
  TITLE: 'title',
  /**
   * Param with source location, from which we navigated to current page.
   */
  LOCATION: 'location',
  /**
   * Owner ID provided for event creation.
   */
  OWNER_ID: 'owner_id',
  /**
   * Type of event to be automatically created.
   */
  TYPE: 'type',
  /**
   * Prefix used to override user preferences with query prefix on page load.
   */
  USER_PREFERENCE_OVERRIDE_PREFIX: 'pref_',
  /**
   * Parameter used for tracking of source that led user to event page.
   */
  VCID: 'vcid',
  /**
   * Parameter used to determine UTM campaign of marketing.
   */
  UTM_CAMPAIGN: 'utm_campaign',
  /**
   * Creation related params.
   */
  CREATION: {
    /**
     * Parameter indicating which clip to target.
     */
    TARGET_VIDEO_PRESET: 'target_video_preset',
  },
  /**
   * Embed interaction tools params.
   */
  INTERACTION: {
    /**
     * Parameter indicating whether user should use auto-auth flow and try to skip login layout if possible.
     * Values expected to be in scope of `EInteractionAuthOption`, but registrant cannot be controlled and limited.
     */
    AUTH_NO_AUTO_SIGN_IN: 'auth_no_auto_sign_in',
    /**
     * Parameter to control which login options are disabled for widget UI.
     */
    AUTH_ROOM_DISABLED_OPTIONS: 'auth_room_disabled_options',
    /**
     * Parameter indicating whether user can collapse login layout.
     */
    AUTH_COLLAPSIBLE_SIGN_IN: 'auth_collapsible_sign_in',
    /**
     * Parameter with possible room password supply.
     */
    AUTH_ROOM_PASSWORD: 'auth_room_password',
    /**
     * Parameter with possible room hash supply.
     */
    AUTH_ROOM_UNLISTED_HASH: 'auth_room_unlisted_hash',
    /**
     * Parameter with serialized user info for injection.
     */
    AUTH_INJECTED_JWT_TOKEN: 'jwt',
    /**
     * Parameter with possible management mode toggle.
     */
    IS_MANAGEMENT_DISABLED: 'is_management_disabled',
    /**
     * Parameter indicating which module enabled.
     */
    MODULE: 'module',
    /**
     * Parameter indicating theme for modules.
     */
    THEME: 'theme',
    /**
     * Attach position for interaction tools sidebar
     */
    SIDEBAR_ATTACH_POSITION: 'sidebar_attach_position',
  },

  GET_STARTED: 'getstarted',
};
